import { composeIO } from 'react-compose-io'
import { debitoBoxIO } from './DebitoBox.IO'
import { DebitoBoxView } from './DebitoBox.View'

export const DebitoBox = composeIO(DebitoBoxView, debitoBoxIO)
